const firebaseConfig = {
    apiKey: "AIzaSyC1WimHqg64_03-Ed9QraW8EBFYLHfKgw4",
    authDomain: "apartment-hunt-f.firebaseapp.com",
    databaseURL: "https://apartment-hunt-f.firebaseio.com",
    projectId: "apartment-hunt-f",
    storageBucket: "apartment-hunt-f.appspot.com",
    messagingSenderId: "1033655288684",
    appId: "1:1033655288684:web:d30db9dacca23955e72949"
}
export default firebaseConfig;